import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { Breadcrumbs, Grid } from "@material-ui/core";
import {
  Create,
  Search,
  CompareArrows,
  GroupAdd,
  PersonAdd,
  VerticalAlignCenter,
  PlaylistAddCheck,
} from "@material-ui/icons";
import { Buscador } from "./Buscador";
import { BannerAfiliado } from "./BannerAfiliado";
import TabAfiliacion from "./TabAfiliacion";
import { fetchSeccionales } from "../../actions/cbos/seccionales";
import { fetchLocalidades } from "../../actions/cbos/localidades";
import { fetchProvincias } from "../../actions/cbos/provincias";
import { fetchCategorias } from "../../actions/cbos/categorias";
import { fetchPlanes } from "../../actions/cbos/planes";
import { fetchTipoDocumentacionParentesco } from "../../actions/documentaciones/tipoDocumentacionParentesco";
import { fetchTipoDocumentacionTipoAfiliacion } from "../../actions/documentaciones/tipoDocumentacionTipoAfiliacion";
import { limpiarListaDocumentacionAfiliado } from "../../actions/documentaciones/documentacion";
import { grupoFamiliarLimpiar } from "../../actions/grupoFamiliar";
import { observacionesLimpiar } from "../../actions/observaciones";
import {
  desSeleccionarAfiliado,
  desSeleccionarAfiliadoConsulta,
} from "../../actions/afiliado";
import { desSeleccionarAfiliadoNuevo } from "../../actions/preAfiliado/afiliado";
import { fetchconveniosPrestacionales } from "../../actions/cbos/conveniosPrestacionales";
import { HomeIngresoTitular } from "./HomeIngresoTitular";
import { changeStepper } from "../../actions/preAfiliado/stepper";
import { HomeCambioTitularidad } from "./HomeCambioTitularidad";
import { HomeFamiliares } from "./familiares/HomeFamiliares";
import { InicioAfiliaciones } from "./InicioAfiliaciones";
import { CandidatosBajasConMotivo } from "./bajas/CandidatosBajasConMotivo";
import { AFILIACIONES_PERMISOS } from "../../utils/permisos";
import { limpiarSeleccionFamiliar } from "../../actions/familiarSeleccionado";
import { BreadcrumbsItemsCustom } from "../BreadcrumbsItemsCustom";
import { ReactivacionesBuscador } from "./Reactivaciones/ReactivacionesBuscador";
import { fetchDocumentacionAfiliacion } from "../../actions/documentaciones/documentacion";
import { fetchGrupoFamiliar } from "../../actions/grupoFamiliar";
import { fetchObservaciones } from "../../actions/observaciones";
import { fetchEmpresasAfiliado } from "../../actions/empresasAfiliado";
import { fetchCertificados } from "../../actions/certificados";
import { traerMovimientos } from "../../actions/movimientos/movimientos";
import { fetchAportes } from "../../actions/aportes";
import { seleccionAfiliado } from "../../actions/afiliado";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  colorSeleccionado: theme.palette.text.primary,
  colorDeseleccionado: theme.palette.text.secondary,
}));

export const AfiliacionesScreen = (props) => {
  const classes = useStyles();
  const { seleccionado, seleccionadoConsulta } = useSelector(
    (state) => state.afiliacion
  );

  const [mostrarInicio /* , setMostrarInicio */] = useState(true);
  const [mostrar1, setMostrar1] = useState(false);
  const [mostrar2, setMostrar2] = useState(false);
  const [mostrar3, setMostrar3] = useState(false);
  const [mostrar5, setMostrar5] = useState(false);
  const [mostrar6, setMostrar6] = useState(false);
  const [mostrar7, setMostrar7] = useState(false);

  const [checkingData, setCheckingData] = useState(true);

  const [direccionValida, setDireccionValida] = useState(false);

  const [esModificacion, setEsModificacion] = useState(false);

  const { items: seccionales, cargada: listaSecCargada } = useSelector(
    (state) => state.seccionales
  );
  const { items: localidades, cargada: listaLocCargada } = useSelector(
    (state) => state.localidades
  );
  const { items: provincias, cargada: listaProvCargada } = useSelector(
    (state) => state.provincias
  );
  const { items: categorias, cargada: listaCategCargada } = useSelector(
    (state) => state.categorias
  );
  const { items: convenios, cargada: listaConvCargada } = useSelector(
    (state) => state.conveniosPrestacionales
  );
  const { items: planes, cargada: listaPlanesCargada } = useSelector(
    (state) => state.planes
  );
  const {
    items: tipoDocumentacionParentesco,
    cargada: listaTipoDocumentacionParentescoCargada,
  } = useSelector((state) => state.tipoDocumentacionParentesco);
  const {
    items: tipoDocumentacionTipoAfiliacion,
    cargada: listaTipoDocumentacionTipoAfiliacionCargada,
  } = useSelector((state) => state.tipoDocumentacionTipoAfiliacion);

  const dispatch = useDispatch();

  const cargarDatosAfiliado = (titularAfiliado) => {
    if (!isNaN(titularAfiliado?.id_afiliado)) {
      dispatch(fetchDocumentacionAfiliacion(titularAfiliado?.id_afiliado));
      dispatch(fetchGrupoFamiliar(titularAfiliado?.id_afiliado));
      dispatch(fetchObservaciones(titularAfiliado?.id_afiliado));
      dispatch(fetchEmpresasAfiliado(titularAfiliado?.id_afiliado));
      dispatch(fetchCertificados(titularAfiliado?.id_afiliado));
      dispatch(traerMovimientos(titularAfiliado?.id_afiliado));
      dispatch(fetchAportes(titularAfiliado?.cuil));
    }
  };

  //efectos para cargar listas DIM
  useEffect(() => {
    if (
      props.location.state?.from !== "/afiliaciones/cambioTitular" &&
      props.location.state?.from !== "/afiliaciones/cambioFamiliar"
    ) {
      dispatch(desSeleccionarAfiliado());
      dispatch(limpiarListaDocumentacionAfiliado());
      dispatch(grupoFamiliarLimpiar());
      dispatch(observacionesLimpiar());
    } else {
      setMostrar2(true);
      setMenu(2);
    }
    if (props.location.state?.from === "/afiliaciones/reactivaciones") {
      const titularAfiliado = props.location.state?.afiliadoSelec;
      dispatch(seleccionAfiliado(titularAfiliado));
      cargarDatosAfiliado(titularAfiliado);
      setMostrar2(true);
      setMenu(2);
    }
    if (props.location.state?.from === "/afiliaciones/bandeja") {
      if (props.location.state?.desdeAceptadas) {
        const titularAfiliado = props.location.state?.afiliadoSelec;
        dispatch(seleccionAfiliado(titularAfiliado, "idConsulta"));

        cargarDatosAfiliado(titularAfiliado);

        setMostrar1(true);
        setMenu(1);
      } else {
        setMostrar3(true);
        setMenu(3);
      }
    }
    // eslint-disable-next-line
  }, [props.location.state?.from, dispatch]);
  useEffect(() => {
    if (!listaPlanesCargada) {
      dispatch(fetchPlanes());
    }
    setCheckingData(false);
  }, [dispatch, planes, listaPlanesCargada]);
  useEffect(() => {
    if (!listaTipoDocumentacionTipoAfiliacionCargada) {
      dispatch(fetchTipoDocumentacionTipoAfiliacion());
    }
    setCheckingData(false);
  }, [
    dispatch,
    tipoDocumentacionTipoAfiliacion,
    listaTipoDocumentacionTipoAfiliacionCargada,
  ]);
  useEffect(() => {
    if (!listaTipoDocumentacionParentescoCargada) {
      dispatch(fetchTipoDocumentacionParentesco());
    }
    setCheckingData(false);
  }, [
    dispatch,
    tipoDocumentacionParentesco,
    listaTipoDocumentacionParentescoCargada,
  ]);
  useEffect(() => {
    if (!listaConvCargada) {
      dispatch(fetchconveniosPrestacionales());
    }
    setCheckingData(false);
  }, [dispatch, listaConvCargada, convenios]);
  useEffect(() => {
    if (!listaCategCargada) {
      dispatch(fetchCategorias());
    }
    setCheckingData(false);
  }, [dispatch, categorias, listaCategCargada]);
  useEffect(() => {
    if (!listaSecCargada) {
      dispatch(fetchSeccionales());
    }
    setCheckingData(false);
  }, [dispatch, seccionales, listaSecCargada]);
  useEffect(() => {
    if (!listaLocCargada) {
      dispatch(fetchLocalidades());
    }
    setCheckingData(false);
  }, [dispatch, localidades, listaLocCargada]);
  useEffect(() => {
    if (!listaProvCargada) {
      dispatch(fetchProvincias());
    }
    setCheckingData(false);
  }, [dispatch, provincias, listaProvCargada]);
  const [menu, setMenu] = useState(0);

  const buttons = [
    {
      color: menu === 1 ? "default" : "inherit",
      classIcon: classes.icon,
      name: "btnConsulta",
      text: "Consulta",
      icon: Search,
    },
    {
      permiso: AFILIACIONES_PERMISOS.MODIFICACION,
      validarAlgunPermiso: [],
      color: menu === 2 ? "default" : "inherit",
      classIcon: classes.icon,
      name: "btnModificar",
      text: "Modificacion",
      icon: Create,
    },
    {
      permiso: AFILIACIONES_PERMISOS.ALTA,
      validarAlgunPermiso: [],
      color: menu === 3 ? "default" : "inherit",
      classIcon: classes.icon,
      name: "btnIngresar",
      text: "Ingreso de Beneficiarios",
      icon: PersonAdd,
    },
    {
      permiso: AFILIACIONES_PERMISOS.ALTA,
      validarAlgunPermiso: [],
      color: menu === 4 ? "default" : "inherit",
      classIcon: classes.icon,
      name: "btnIngresarFamiliar",
      text: "Ingreso de Familiares",
      icon: GroupAdd,
    },
    {
      permiso: AFILIACIONES_PERMISOS.BAJA,
      validarAlgunPermiso: [],
      color: menu === 5 ? "default" : "inherit",
      classIcon: classes.icon,
      name: "btnAltasyBajas",
      text: "Bajas",
      icon: VerticalAlignCenter,
    },
    {
      permiso: AFILIACIONES_PERMISOS.CAMBIO_TITULARIDAD,
      validarAlgunPermiso: [],
      color: menu === 6 ? "default" : "inherit",
      classIcon: classes.icon,
      name: "btnCambioTitularidad",
      text: "Cambio de Titularidad",
      icon: CompareArrows,
    },
    {
      permiso: AFILIACIONES_PERMISOS.REACTIVACION,
      validarAlgunPermiso: [],
      color: menu === 7 ? "default" : "inherit",
      classIcon: classes.icon,
      name: "btnReactivacion",
      text: "Reactivaciones",
      icon: PlaylistAddCheck,
    },
  ];
  //****************************************** */
  const handleClick = (e) => {
    e.preventDefault();
    switch (e.currentTarget.name) {
      case "btnConsulta":
        dispatch(desSeleccionarAfiliadoConsulta());
        setMostrar1(true);
        setMenu(1);
        break;
      case "btnModificar":
        dispatch(desSeleccionarAfiliado());
        dispatch(desSeleccionarAfiliadoNuevo());
        setMostrar2(true);
        setMenu(2);
        setEsModificacion(true);
        break;
      case "btnIngresar":
        dispatch(changeStepper(0));
        dispatch(desSeleccionarAfiliado());
        dispatch(desSeleccionarAfiliadoNuevo());
        setDireccionValida(true);
        setMostrar3(true);
        setMenu(3);
        break;
      case "btnIngresarFamiliar":
        dispatch(limpiarSeleccionFamiliar());
        dispatch(desSeleccionarAfiliadoConsulta());
        dispatch(changeStepper(0));
        dispatch(desSeleccionarAfiliado());
        dispatch(desSeleccionarAfiliadoNuevo());
        setMenu(4);
        break;
      case "btnAltasyBajas":
        setMenu(5);
        setMostrar5(true);
        break;
      case "btnCambioTitularidad":
        setMenu(6);
        setMostrar6(true);
        break;
      case "btnReactivacion":
        dispatch(desSeleccionarAfiliado());
        dispatch(desSeleccionarAfiliadoConsulta());
        setMenu(7);
        setMostrar7(true);
        break;
      default:
        break;
    }
  };
  if (checkingData) {
    return <h1>Cargando....</h1>;
  }

  return (
    <>
      <div className={classes.root}>
        <Grid
          container
          spacing={1}
          direction="row"
          justify="center"
          alignItems="center"
        >
          <Grid item xs={12} styles={{ padding: 5 }}>
            <Breadcrumbs style={{ color: "#FAFAFA" }} aria-label="breadcrumb">
              <BreadcrumbsItemsCustom
                buttons={buttons}
                handleClick={handleClick}
              />
            </Breadcrumbs>
          </Grid>
          {mostrarInicio && menu === 0 && <InicioAfiliaciones />}
          {mostrar1 && menu === 1 && (
            <Grid item xs={12} sm={4} md={6}>
              <Buscador idConsulta={"idConsulta"} />
            </Grid>
          )}
          <Grid item xs={12}>
            {seleccionadoConsulta && menu === 1 && <BannerAfiliado consulta={true}/>}
          </Grid>
          {seleccionadoConsulta && menu === 1 && (
            <TabAfiliacion
              idForm="formConsulta"
              desdeBandejaAceptadas={props.location.state?.desdeAceptadas}
            />
          )}
          {mostrar2 && menu === 2 && (
            <Grid item xs={12} sm={4} md={6}>
              <Buscador />
            </Grid>
          )}
          <Grid item xs={12}>
            {seleccionado && menu === 2 && <BannerAfiliado />}
          </Grid>
          <Grid item xs={12}>
            {seleccionado && menu === 2 && (
              <TabAfiliacion
                fromCambioFamiliar={
                  props.location.state?.from === "/afiliaciones/cambioFamiliar"
                    ? true
                    : false
                }
                esModificacion={esModificacion}
              />
            )}
          </Grid>
          {mostrar5 && menu === 5 && <CandidatosBajasConMotivo />}
          {mostrar3 && menu === 3 && (
            <Grid container justify="center">
              <HomeIngresoTitular
                fromBandejaFamiliar={
                  props.location.state?.from === "/afiliaciones/bandeja" &&
                  props.location.state?.familiar
                    ? true
                    : false
                }
                fromBandeja={
                  props.location.state?.from === "/afiliaciones/bandeja" &&
                  !direccionValida
                    ? true
                    : false
                }
              />
            </Grid>
          )}
          {/*(afiliadoEncontrado && menu===3) && <TabIngresoTitular /> */}
          {mostrar6 && menu === 6 && (
            <Grid>
              <HomeCambioTitularidad />
            </Grid>
          )}
          {mostrar7 && menu === 7 && (
            <Grid item xs={12} sm={4} md={6}>
              <ReactivacionesBuscador idConsulta={"idConsulta"} />
            </Grid>
          )}
          {seleccionadoConsulta && menu === 7 && (
            <TabAfiliacion idForm="formConsulta" isReactivaciones />
          )}
          {menu === 4 && (
            <Grid item lg={12}>
              <HomeFamiliares />
            </Grid>
          )}
        </Grid>
      </div>
    </>
  );
};
